import React from 'react';
import moment from 'moment';
import { FireIcon, EyeIcon } from '@heroicons/react/outline';

const ShowOrgProjects = ({projects, setContentMsg, setDailyProject, setActiveView }) => {

    return (
        <div>
            {projects?.map((project, index)=>{
                return(
                    <div
                    key={index}
                    className="bg-gray-50 rounded-lg"
                    style={{marginBottom: '10px'}}
                    //onClick={()=> {setContentMsg(project.ContentCreated); setDailyProject(project)}}
                    >
                        <div className="px-4 py-5 sm:p-6">
                            <p 
                            style={{
                                fontWeight: 700,
                                fontSize: 15,
                                marginBottom: '5px'
                            }}
                            >
                                {project?.ProspectName}
                            </p>
                            <p className="text-sm text-gray-500 truncate mt-2">
                                <b>Author:</b> {project?.AuthorFirstName} {project?.AuthorLastName} 
                            </p>
                            <p className="text-sm text-gray-500 truncate mt-2">
                                <b>Total content:</b> {project?.ContentCreated ? project?.ContentCreated?.length : '0'} 
                            </p>
                            <p className="text-sm text-gray-500 truncate mt-2">
                                <b>Copied content:</b> {(project?.ContentCopied && project?.ContentCopied !== '') ? 'Yes' : 'No'} 
                            </p>
                            <p className="text-sm text-gray-500 truncate mt-2">
                                {project?.CreatedAt ? 
                                    <span>{moment(project?.CreatedAt?.toDate()).calendar()}</span>
                                :
                                    <span>{moment(project?.createdAt?.toDate()).calendar()}</span>
                                }
                            </p>
                        </div>
                        <div className="flex">
                        <div
                        className="flex p-1 border-2 cursor-pointer border-blue-500 bg-blue-500 hover:bg-blue-400 text-white focus:outline-none w-1/2 text-center w-1/2 text-center"
                        onClick={()=> {
                            setContentMsg(project.ContentCreated); 
                            setDailyProject(project);
                            setActiveView('Content')
                        }}
                        >
                            <EyeIcon className="h-4 mr-1" style={{marginTop: 1}}/><span className="-mt-0.5">View </span>    
                        </div>
                        <div
                        className="flex p-1 border-2 cursor-pointer border-red-500 bg-red-500 hover:bg-red-400 text-white focus:outline-none w-1/2 text-center"
                        onClick={()=> {
                            if(project.ContentLiked){setContentMsg(project.ContentLiked)}else{setContentMsg('undefinded')};
                            setDailyProject(project);
                            setActiveView('Fire')
                        }}
                        >
                            < FireIcon className="h-4 mr-1" style={{marginTop: 1}}/><span className="-mt-0.5">Fire</span>
                        </div>
                    </div>    
                    </div>
                )
            })}
            
        </div>
    )
}

export default ShowOrgProjects
